import {AppState} from '../../core.module';

export const selectHttpStatus = (state: AppState) => state.httpStatus;
